import { toast } from "sonner";
import { updateBasicDetails } from "./api";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
    const payload = {};

    Object.entries(values).forEach(([key, value]) => {
        if (
            ![].includes(key)
        ) {
            payload[key] = value;
        }
    });

    return payload;
}

export function useUpdateBasicDetails() {
    return useMutation({
        mutationFn: async ({ caseStudyId, values }) => {
            const payload = buildPayload(values);

            const response = await updateBasicDetails({ caseStudyId, item: payload });
            return response;
        },
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Basic Details Updated Successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
